import { createSelector } from '@ngrx/store';
import { getMenuState, MenuState } from '../menu.reducer';
import { adapter, ConsumerState } from './consumers.reducer';
import {asyncActionState} from '@emm/core/util/async-action-state';
import {LocationSetsSelectors} from '@emm/menu/store/location-sets/location-sets.selectors';
import {MenuKey, MenuKeyContext} from '@emm/core/models/menu-key.model';
import {MenuBaseSelectors} from '@emm/menu/store/base/menu-base.selectors';
import {SubmenusSelectors} from '@emm/menu/store/submenus/submenus.selectors';

const getState = createSelector(getMenuState, (state: MenuState) => state?.consumer);

const entitySelectors = adapter.getSelectors(getState);
const asyncActionStateSelectors = asyncActionState.getSelectors(getState);

const getSelectedTag = createSelector(getState, (state: ConsumerState) => state.selectedTag);

const getSelected = createSelector(
    entitySelectors.selectEntities,
    getSelectedTag,
    (entities, selectedTag) => selectedTag && entities[selectedTag]
);

const getValidAll = createSelector(
    entitySelectors.selectAll,
    asyncActionStateSelectors.getHasError,
    asyncActionStateSelectors.getSuccess,
    (items, hasError, success) => (!hasError && success ? items : null)
);
const getMenuKey = createSelector(
    getSelectedTag,
    LocationSetsSelectors.getSelectedTag,
    (consumerTag, locationSetTag) =>
        ({
            consumer: consumerTag,
            location: locationSetTag
        } as MenuKey)
);

const getMenuParams = createSelector(
    getMenuKey,
    MenuBaseSelectors.getEffectiveDate,
    (menuKey, effectiveDate) => ({
        effectiveDate,
        menuKey
    })
);

// Consider moving to different file and/or consolidate with above getMenuKey
const getMenuKeyContext = createSelector(
    getSelectedTag,
    LocationSetsSelectors.getSelectedTag,
    SubmenusSelectors.getSelected,
    (consumer, location, submenu) =>
        ({
            consumer,
            location,
            submenu
        } as MenuKeyContext)
);

const getMenuParamsContext = createSelector(
    getMenuKeyContext,
    MenuBaseSelectors.getEffectiveDate,
    (menuKey, effectiveDate) => ({
        effectiveDate,
        menuKey
    })
);

export const ConsumersSelectors = {
    entitySelectors,
    ...asyncActionStateSelectors,
    getSelectedTag,
    getSelected,
    getValidAll,
    getMenuKey,
    getMenuKeyContext,
    getMenuParams,
    getMenuParamsContext
};
